// src/pages/ContentEditor/components/EditorTabs.js
import React from 'react';
import { Box, Paper, Tabs, Tab, alpha } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import FluencyTab from './tabs/FluencyTab';
import VocabularyTab from './tabs/VocabularyTab';
import ComprehensionTab from './tabs/ComprehensionTab';
import DecodeWordsTab from './tabs/DecodeWordsTab';
import TabPanel from '../../../../../components/common/TabPanel';

// A11y props for tabs
function a11yProps(index) {
  return {
    id: `content-tab-${index}`,
    'aria-controls': `content-tabpanel-${index}`,
  };
}

const EditorTabs = ({ 
  tabValue, 
  formData, 
  onTabChange, 
  onNestedChange, 
  onAddItem, 
  onRemoveItem 
}) => {
  const theme = useTheme();
  
  return (
    <Paper 
      sx={{ 
        borderRadius: 1,
        backgroundColor: theme.palette.background.paper,
        border: '1px solid',
        borderColor: alpha(theme.palette.common.white, 0.1)
      }}
    >
      <Box sx={{ borderBottom: 1, borderColor: alpha(theme.palette.common.white, 0.1) }}>
        <Tabs
          value={tabValue}
          onChange={onTabChange}
          aria-label="content tabs"
          indicatorColor="primary"
          textColor="primary"
          sx={{
            '& .MuiTabs-indicator': {
              backgroundColor: theme.palette.primary.main,
            },
            '& .MuiTab-root': {
              color: theme.palette.text.secondary,
              '&.Mui-selected': {
                color: theme.palette.primary.main,
              }
            }
          }}
        >
          <Tab label="Fluency" {...a11yProps(0)} />
          <Tab label="Vocabulary" {...a11yProps(1)} />
          <Tab label="Comprehension" {...a11yProps(2)} />
          <Tab label="Decode Words" {...a11yProps(3)} />
        </Tabs>
      </Box>
      
      <TabPanel value={tabValue} index={0}>
        <FluencyTab 
          paragraphs={formData.fluencyActivity.paragraphs}
          onNestedChange={onNestedChange}
          onAddItem={() => onAddItem('fluencyActivity')}
          onRemoveItem={(index) => onRemoveItem('fluencyActivity', index)}
        />
      </TabPanel>
      
      <TabPanel value={tabValue} index={1}>
        <VocabularyTab 
          sentences={formData.vocabularyActivity.sentences}
          onNestedChange={onNestedChange}
          onAddItem={() => onAddItem('vocabularyActivity')}
          onRemoveItem={(index) => onRemoveItem('vocabularyActivity', index)}
        />
      </TabPanel>
      <TabPanel value={tabValue} index={2}>
        <ComprehensionTab 
          questions={formData.comprehensionActivity.questions}
          onNestedChange={onNestedChange}
          onAddItem={() => onAddItem('comprehensionActivity')}
          onRemoveItem={(index) => onRemoveItem('comprehensionActivity', index)}
        />
      </TabPanel>
      
      <TabPanel value={tabValue} index={3}>
        <DecodeWordsTab 
          words={formData.decodeActivity.words}
          onNestedChange={onNestedChange}
          onAddItem={() => onAddItem('decodeActivity')}
          onRemoveItem={(index) => onRemoveItem('decodeActivity', index)}
        />
      </TabPanel>
    </Paper>
  );
};

export default EditorTabs;